import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap-v5";
import { useHistory } from "react-router-dom";
import { KTSVG } from "../../../../_metronic/helpers";
import { CreateExpertiseModal } from "./modals/CreateExpertiseModal";
import { ExpertiseExpertTab } from "./tabs/ExpertiseExpertTab";
import { GeneralProfileExpertTab } from "./tabs/GeneralProfileExpertTab";
import { CommunityExpertTab } from "./tabs/CommunityExpertTab";

type Props = {
    open: boolean;
    partner: any;
    onClose: (close: boolean) => void;
    onEdit: (id:number) => void;
};

const DetailExpertDrawer:React.FC<Props> = ({ open, onClose, partner, onEdit }) => {
    const [activeTab, setActiveTab] = useState(1)
    const [createRecord, setCreateRecord] = useState(false);

    useEffect(() => {
    }, []);

    const handleCancel = () => {
        onClose(false);
    }

    const handleEdit = () => {
        onClose(false)
        onEdit(partner.id)
    }

    const handleChangeTab = async (tab:number) => {
        setActiveTab(tab);
    }

    return (<Modal show={open} 
        onHide={handleCancel}
        backdrop='static'
        enforceFocus={false}
        dialogClassName='experience-detail-modal w-drawer-partner'
        contentClassName='experience-detail-content'
        backdropClassName='experience-detail-backdrop'
        className={`w-100`}>
        <div className={`admin-experience-details-container`}>
            {/* Header */}
            <div className="admin-experience-details-header">
                <h2 className="admin-experience-details-title">
                    Expert Details
                </h2>
                <div className="rm-style-3 cursor-pointer" onClick={()=>onClose(false)}>
                    <KTSVG path="/media/svg/nobilis/closeX.svg" className="rm-style-4" />
                </div>
            </div>

            <div className="d-flex flex-row w-100" style={{ gap: '15px' }}>
                <div className="admin-expert-details-metrics">
                    <span className="type">
                        Performance
                    </span>
                    <span className="value">
                        7,6 / 10
                    </span>
                </div>
                
                <div className="admin-expert-details-metrics">
                    <span className="type">
                        Reputation
                    </span>
                    <div className="d-flex flex-row flex-nowrap" style={{ gap: 'var(--margin-small, 5px)' }}>
                        {[true,true,true,true,false].map((r) => (
                            <>
                                {r ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M6.86497 1.75482L7.74497 3.51482C7.86497 3.75983 8.18497 3.99482 8.45497 4.03982L10.05 4.30482C11.07 4.47482 11.31 5.21482 10.575 5.94482L9.33497 7.18482C9.12497 7.39482 9.00997 7.79982 9.07497 8.08982L9.42997 9.62482C9.70997 10.8398 9.06497 11.3098 7.98997 10.6748L6.49497 9.78982C6.22497 9.62982 5.77997 9.62982 5.50497 9.78982L4.00995 10.6748C2.93995 11.3098 2.28995 10.8348 2.56995 9.62482L2.92495 8.08982C2.98995 7.79982 2.87495 7.39482 2.66495 7.18482L1.42495 5.94482C0.694955 5.21482 0.929955 4.47482 1.94995 4.30482L3.54495 4.03982C3.80995 3.99482 4.12995 3.75983 4.24995 3.51482L5.12997 1.75482C5.60997 0.799824 6.38997 0.799824 6.86497 1.75482Z" stroke="#460107" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                ): (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M2.63995 9.32482L2.92495 8.08982C2.98995 7.79982 2.87495 7.39482 2.66495 7.18482L1.42495 5.94482C0.694955 5.21482 0.929955 4.47482 1.94995 4.30482L3.54495 4.03982C3.80995 3.99482 4.12995 3.75983 4.24995 3.51482L5.12997 1.75482C5.60497 0.799824 6.38497 0.799824 6.86497 1.75482L7.74497 3.51482C7.79997 3.62982 7.90497 3.73982 8.01997 3.83482" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M10.0498 4.30518C11.0698 4.47518 11.3098 5.21518 10.5748 5.94518L9.33476 7.18518C9.12476 7.39518 9.00976 7.80018 9.07476 8.09018L9.42976 9.62518C9.70976 10.8402 9.06476 11.3102 7.98976 10.6752L6.49476 9.79018C6.22476 9.63018 5.77976 9.63018 5.50476 9.79018L4.00977 10.6752" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11 1L1 11" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                )}
                            </>
                        ))}
                    </div>
                </div>
            </div>

            {/* Action */}
            <div className="admin-experience-details-action">
                <div className='tab-navigation w-100'>
                    <div className='d-flex flex-row'>
                        <div className={`tab-navigation__item ${activeTab === 1 ? 'tab-navigation__item--selected' : ''}`}
                        onClick={()=>handleChangeTab(1)}>
                            <div className='tab-navigation__label'>General Profile</div>
                        </div>
                        <li className={`separator-vertical d-flex`}>
                            <hr />
                        </li>
                    </div>
                    <div className='d-flex flex-row'>
                        <div className={`tab-navigation__item ${activeTab === 2 ? 'tab-navigation__item--selected' : ''}`}
                        onClick={()=>handleChangeTab(2)}>
                            <div className='tab-navigation__label'>Expertise</div>
                        </div>
                        <li className={`separator-vertical d-flex`}>
                            <hr />
                        </li>
                    </div>
                    <div className='d-flex flex-row'>
                        <div className={`tab-navigation__item ${activeTab === 3 ? 'tab-navigation__item--selected' : ''}`}
                        onClick={()=>handleChangeTab(3)}>
                            <div className='tab-navigation__label'>Community</div>
                        </div>
                    </div>
                </div>
                <div className='tab-navigation w-100 gap-3 justify-content-end'>
                    <button className="tap-add-experience-2-btn-secondary" onClick={()=> setCreateRecord(true)}>
                        <KTSVG path='/media/svg/nobilis/calendar-edit.svg' />&nbsp;
                        <span>Create Expertise</span>
                    </button>
                    <div className="tap-add-experience-2-btn-main" role="button" onClick={handleEdit}>
                        <div className="tap-host-button-text tap-flex-center">
                            Edit
                            &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                        </div>
                    </div>
                </div>
            </div>
            {activeTab === 1 && (
                <GeneralProfileExpertTab partner={partner}/>
            )}
            {activeTab === 2 && (
                <ExpertiseExpertTab partner={partner}/>
            )}
            {activeTab === 3 && (
                <CommunityExpertTab partner={partner} />
            )}
            
        </div>
        <CreateExpertiseModal 
            close={() => setCreateRecord(false)}
            show={createRecord}
            partner={partner}
        />
    </Modal>);
}

export { DetailExpertDrawer };

